import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

export default function ClientsPage({ cabinetId = null }) {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  useEffect(() => {
    if (cabinetId == null) return;
    chargerClients();
  }, [cabinetId]);

  async function chargerClients() {
    setLoading(true);

    const { data, error } = await supabase
      .from("clients")
      .select("*")
      .eq("cabinet_id", cabinetId)
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Erreur chargement clients:", error);
    } else {
      setClients(data || []);
    }

    setLoading(false);
  }

  function updateField(field, value) {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  }

  async function ajouterClient() {
    if (!form.name || !form.email) {
      alert("Remplis au minimum le nom et l email.");
      return;
    }

    const { error } = await supabase.from("clients").insert([
      {
        name: form.name,
        email: form.email,
        phone: form.phone,
        address: form.address,
        cabinet_id: cabinetId,
      },
    ]);

    if (error) {
      console.error("Erreur ajout client:", error);
      alert("Erreur lors de l ajout du client.");
      return;
    }

    setForm({
      name: "",
      email: "",
      phone: "",
      address: "",
    });

    chargerClients();
  }

  async function supprimerClient(id) {
    const { error } = await supabase.from("clients").delete().eq("id", id).eq("cabinet_id", cabinetId);

    if (error) {
      console.error("Erreur suppression client:", error);
      alert("Erreur lors de la suppression du client.");
      return;
    }

    chargerClients();
  }

  if (cabinetId == null) {
    return <div style={{ padding: 24, textAlign: "center", color: "#8B7361" }}>Chargement...</div>;
  }

  return (
    <main style={{ padding: 32 }}><h1>Clients</h1><p>Test de connexion Supabase</p><div style={{ display: "grid", gap: 12, maxWidth: 700, marginBottom: 24 }}><input
          placeholder="Nom"
          value={form.name}
          onChange={(e) => updateField("name", e.target.value)}
        /><input
          placeholder="Email"
          value={form.email}
          onChange={(e) => updateField("email", e.target.value)}
        /><input
          placeholder="Téléphone"
          value={form.phone}
          onChange={(e) => updateField("phone", e.target.value)}
        /><input
          placeholder="Adresse"
          value={form.address}
          onChange={(e) => updateField("address", e.target.value)}
        /><button onClick={ajouterClient}>Ajouter le client</button></div><h3>Liste des clients</h3>
      {loading && <p>Chargement...</p>}

      <table border="1" cellPadding="8" style={{ width: "100%", maxWidth: 1000 }}><thead><tr><th>Nom</th><th>Email</th><th>Téléphone</th><th>Adresse</th><th>Action</th></tr></thead><tbody>
          {clients.map((client) => (
            <tr key={client.id}><td>{client.name}</td><td>{client.email}</td><td>{client.phone}</td><td>{client.address}</td><td><button onClick={() => supprimerClient(client.id)}>Supprimer</button></td></tr>
          ))}
        </tbody></table></main>
  );
}
